module.exports = __webpack_public_path__ + "img/ic-my-profile-library.5b9d123e.png";